import { useMemo } from 'react';

/** Звёздное небо на фоне. Позиции генерируются один раз за жизнь компонента. */
export function Stars({ count = 40 }: { count?: number }) {
  const stars = useMemo(
    () => Array.from({ length: count }, (_, i) => ({ id: i, left: Math.random() * 100, top: Math.random() * 100, size: 1 + Math.random() * 2, delay: Math.random() * 3 })),
    [count],
  );
  return (
    <div className="stars" aria-hidden>
      {stars.map((s) => <i key={s.id} style={{ left: `${s.left}%`, top: `${s.top}%`, width: s.size, height: s.size, animationDelay: `${s.delay}s` }} />)}
    </div>
  );
}
